// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkPreview__container-cad8e4 {
  border-top: solid 1px var(--base-20);
}

.LinkPreview__link-b3cee2 {
  text-decoration: none;
}

.LinkPreview__preview-ee759f {
  padding: 7px 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.LinkPreview__preview-container-c2c317 {
  max-width: 776px;
  padding-inline-start: 48px;
}

.LinkPreview__title-a39765 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--brand-primary-40);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.LinkPreview__miniature-title-b88788 {
  color: var(--brand-primary-40);
}

.LinkPreview__miniature-text-ab8c65 {
  color: var(--base-80);
}

.LinkPreview__miniature-icon-a98c37 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/LinkPreview/styles.m.css"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,8BAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF","sourcesContent":[".container {\n  border-top: solid 1px var(--base-20);\n}\n\n.link {\n  text-decoration: none;\n}\n\n.preview {\n  padding: 7px 12px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.preview-container {\n  max-width: 776px;\n  padding-inline-start: 48px;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--brand-primary-40);\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.miniature-title {\n  color: var(--brand-primary-40);\n}\n\n.miniature-text {\n  color: var(--base-80);\n}\n\n.miniature-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LinkPreview__container-cad8e4`,
	"link": `LinkPreview__link-b3cee2`,
	"preview": `LinkPreview__preview-ee759f`,
	"preview-container": `LinkPreview__preview-container-c2c317`,
	"previewContainer": `LinkPreview__preview-container-c2c317`,
	"title": `LinkPreview__title-a39765`,
	"miniature-title": `LinkPreview__miniature-title-b88788`,
	"miniatureTitle": `LinkPreview__miniature-title-b88788`,
	"miniature-text": `LinkPreview__miniature-text-ab8c65`,
	"miniatureText": `LinkPreview__miniature-text-ab8c65`,
	"miniature-icon": `LinkPreview__miniature-icon-a98c37`,
	"miniatureIcon": `LinkPreview__miniature-icon-a98c37`
};
module.exports = ___CSS_LOADER_EXPORT___;
